import React from 'react';
import { useLang } from '../contexts/LanguageContext';

export default function TerminiPage() {
  const { t } = useLang();

  const sections = [
    {
      title: { it: '1. Oggetto', en: '1. Scope' },
      text: {
        it: "I presenti Termini e Condizioni regolano l'acquisto di prodotti effettuato tramite il sito biolosophy. Effettuando un ordine, il cliente dichiara di aver letto e accettato integralmente le presenti condizioni.",
        en: 'These Terms and Conditions govern the purchase of products through the biolosophy website. By placing an order, the customer declares to have read and fully accepted these conditions.',
      },
    },
    {
      title: { it: '2. Prodotti e Prezzi', en: '2. Products and Prices' },
      text: {
        it: "Tutti i prodotti sono realizzati in Italia con tessuti biologici certificati. I prezzi sono espressi in Euro (€) e comprensivi di IVA. biolosophy si riserva il diritto di modificare i prezzi in qualsiasi momento, fermo restando il prezzo applicato al momento dell'ordine.",
        en: 'All products are made in Italy with certified organic fabrics. Prices are in Euro (€) and include VAT. biolosophy reserves the right to change prices at any time, without affecting the price applied at the time of the order.',
      },
    },
    {
      title: { it: '3. Ordini e Pagamenti', en: '3. Orders and Payments' },
      text: {
        it: "I pagamenti possono essere effettuati tramite carta di credito/debito (Stripe) o PayPal. L'ordine si intende concluso al momento della conferma del pagamento. In caso di mancata disponibilità del prodotto, il cliente sarà rimborsato integralmente.",
        en: 'Payments can be made by credit/debit card (Stripe) or PayPal. The order is finalised upon payment confirmation. If a product is unavailable, the customer will be fully refunded.',
      },
    },
    {
      title: { it: '4. Programma Biolosophy Value', en: '4. Biolosophy Value Program' },
      text: {
        it: "Il programma Biolosophy Value consente di restituire capi biolosophy acquistati in precedenza in cambio di uno sconto sul nuovo acquisto: 20% entro il primo anno di acquisto, con incremento del 10% per ogni anno successivo, fino a un capo gratuito di pari valore al nono anno. Lo sconto si applica dopo l'approvazione del capo restituito, che deve essere in condizioni idonee alla rigenerazione.",
        en: 'The Biolosophy Value program allows customers to return previously purchased biolosophy garments in exchange for a discount on a new purchase: 20% within the first year of purchase, increasing by 10% for each following year, up to a free garment of equal value in the ninth year. The discount is applied after approval of the returned garment, which must be in suitable condition for regeneration.',
      },
    },
    {
      title: { it: '5. Capi Pre-Loved', en: '5. Pre-Loved Garments' },
      text: {
        it: 'I capi Pre-Loved sono articoli rigenerati provenienti dal programma Biolosophy Value, verificati e certificati. Sono pezzi unici venduti nelle condizioni descritte nella scheda prodotto e godono delle stesse tutele dei capi nuovi.',
        en: 'Pre-Loved garments are regenerated items from the Biolosophy Value program, verified and certified. They are unique pieces sold in the condition described on the product page and enjoy the same protections as new garments.',
      },
    },
    {
      title: { it: '6. Spedizioni e Resi', en: '6. Shipping and Returns' },
      text: {
        it: 'Le condizioni di spedizione e reso sono dettagliate nella pagina "Spedizioni e Resi". Il diritto di recesso può essere esercitato entro 14 giorni dalla consegna, ai sensi del Codice del Consumo (D.Lgs. 206/2005).',
        en: 'Shipping and return conditions are detailed on the "Shipping & Returns" page. The right of withdrawal may be exercised within 14 days of delivery, in accordance with the Italian Consumer Code (Legislative Decree 206/2005).',
      },
    },
    {
      title: { it: '7. Garanzia', en: '7. Warranty' },
      text: {
        it: 'Tutti i prodotti sono coperti dalla garanzia legale di conformità di 24 mesi prevista dal Codice del Consumo.',
        en: 'All products are covered by the 24-month legal warranty of conformity provided by the Italian Consumer Code.',
      },
    },
    {
      title: { it: '8. Legge Applicabile e Foro Competente', en: '8. Governing Law and Jurisdiction' },
      text: {
        it: 'I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia è competente il foro del luogo di residenza o domicilio del consumatore.',
        en: "These Terms are governed by Italian law. Any dispute falls under the jurisdiction of the courts of the consumer's place of residence or domicile.",
      },
    },
    {
      title: { it: '9. Contatti', en: '9. Contact' },
      text: {
        it: 'Per qualsiasi informazione è possibile contattarci a info@biolosophy.it.',
        en: 'For any information, you can contact us at info@biolosophy.it.',
      },
    },
  ];

  return (
    <div data-testid="termini-page" className="min-h-screen bg-[#FAF9F6] pt-24 pb-24">
      <section className="px-6 md:px-12 lg:px-24 py-16">
        <div className="max-w-3xl">
          <p className="overline mb-4">{t({ it: 'Legale', en: 'Legal' })}</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#1C1917] mb-4">
            {t({ it: 'Termini e Condizioni', en: 'Terms and Conditions' })}
          </h1>
          <p className="text-sm text-[#57534E] mb-16">
            {t({ it: 'Ultimo aggiornamento: giugno 2026', en: 'Last updated: June 2026' })}
          </p>

          <div className="space-y-10">
            {sections.map((s) => (
              <div key={s.title.it}>
                <h2 className="text-lg font-medium text-[#1C1917] mb-3">{t(s.title)}</h2>
                <p className="text-sm text-[#1C1917]/70 leading-relaxed">{t(s.text)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
